module.exports = [{"name":"Sedentary","descriptions":["Most of the day is spent sitting","e.g. Programmer"]},{"name":"Light","descriptions":["Often walking for brief periods","e.g. Doctor"]},{"name":"Moderate","descriptions":["Often walking for long periods","e.g. Waiter"]},{"name":"Active","descriptions":["Daily work is labor intensive","e.g. Landscaper"]},{"name":"Extra Active","descriptions":["Daily work is extremely taxing","e.g. Pro Athlete"]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/Intake/Custom/ActivityLevels.json
// module id = 455
// module chunks = 0